import React from "react";
import refrence from "../../scenes/Dashboard/reference";
import { useSelector } from "react-redux";

// Caution: before you start going through, I used icons as pure SVG format thats why the code is a bit bulky, always close SVG bracket to maintain code readability.

function EmployerHeader() {
  const publicInfo = useSelector(e => e.public);
  const pub = publicInfo.message?.profile;
  const userInfor = publicInfo.message?.user
  return (
    <div className="w-full tablet:w-[50%] py-8 bg-[#EFECFF] tablet:rounded-2xl flex justify-center px-[2%] tablet:px-[10%] ">
      {/* div for profile */}
      <div className="flex flex-col items-center gap-4 tablet:gap-9">
        {/* profile photo  */}
        <img
          src={userInfor?.profile_pics !== undefined ? userInfor?.profile_pics : refrence.profilephoto1}
          alt=""
          className="rounded-full h-20 w-20 tablet:h-40 tablet:w-40"
        />
        <div className=" flex flex-col gap-10 items-center ">
          {/* text content here  */}
          <div className="flex flex-col gap-3 items-center">
            <h2 className=" font-semibold tablet:text-2xl text-lg">
              Adeleke Tolulope
            </h2>
            <p className="font-semibold text-base text-[#898989]">
              Professional Plumber
            </p>
            {/* container for stars and the rest  */}
            <div className=" tablet:flex gap-2">
              <img src={refrence.fivestars} alt="" />
              <p className="font-medium text-xs">
                5.0{" "}
                <span className=" font-normal text-[#5843BD]">
                  (See all 25 reviews)
                </span>
              </p>
            </div>
          </div>
          {/* buttons  */}
          <div className="mt-4 tablet:mt-0 font-semibold text-base flex-row flex gap-2 tablet:gap-6">
            <button className=" bg-[#5843BD] border border-[#5843BD] hover:text-[#5843BD] hover:bg-[#E1DCF9] px-5 py-3 rounded-2xl text-[#ffffff] whitespace-nowrap">
              Hire Me
            </button>
            <button className=" bg-[#E1DCF9] border border-[#5843BD] hover:text-[#ffffff] hover:bg-[#5843BD] hover:border-[#ffffff] px-5 py-3 rounded-2xl text-[#5843BD] whitespace-nowrap">
              Share Profile
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmployerHeader;